module.exports = __webpack_public_path__ + "img/47_ProLabel_POM.2b1089f5.png";